export default {
  clearAll() {
    window.sessionStorage.clear();
  },

  get(key) {
    try {
      const value = window.sessionStorage.getItem(key);
      return value ? JSON.parse(value) : null;
    } catch (error) {
      return window.sessionStorage.getItem(key);
    }
  },

  set(key, value) {
    if (typeof value === 'object') {
      window.sessionStorage.setItem(key, JSON.stringify(value));
    } else {
      window.sessionStorage.setItem(key, value);
    }
  },

  remove(key) {
    window.sessionStorage.removeItem(key);
  },

  // Stores `value` wrapped with an absolute expiry (now + ttl, in ms), reusing
  // set() for serialization. Pair with getWithExpiry, which drops the entry once
  // it expires.
  setWithExpiry(key, value, ttl) {
    try {
      this.set(key, { value, expiresAt: Date.now() + ttl });
    } catch (error) {
      // sessionStorage unavailable (private mode / quota) — drop any stale entry.
      this.remove(key);
    }
  },

  // Returns the stored value, or null if missing, expired, or not written via
  // setWithExpiry. Expired/malformed entries are removed as a side effect.
  getWithExpiry(key) {
    try {
      const item = this.get(key);
      if (item === null) return null;
      if (typeof item !== 'object' || item.expiresAt === undefined) {
        this.remove(key);
        return null;
      }
      if (Date.now() > item.expiresAt) {
        this.remove(key);
        return null;
      }
      return item.value;
    } catch (error) {
      return null;
    }
  },
};
